// Replicate behavior of the CMN navigation component: add/remove the `popover` attribute at the
// same breakpoint so desktop shows nav links inline and mobile uses the overlay.

const navLinks = document.getElementById("cmnh-navigation__links");

if (navLinks) {
    const mq = window.matchMedia("(max-width: 768px)");

    const syncPopover = (e: MediaQueryList | MediaQueryListEvent) => {
        if (e.matches) {
            navLinks!.setAttribute("popover", "");
        } else {
            if (navLinks!.matches(":popover-open")) {
                (navLinks as any).hidePopover();
            }
            navLinks!.removeAttribute("popover");
        }
    };

    mq.addEventListener("change", syncPopover);
    syncPopover(mq);
}
